import { ApiClient } from "../config/apiClient";

const BACKEND_URL = import.meta.env.VITE_GO_BACKEND_URL;

type FeedbackType = "positive" | "negative";

export const sendFeedback = async (
  documentId: string,
  feedback: FeedbackType
): Promise<void> => {
  try {
    const axiosInstance = ApiClient.getInstance().getAxiosInstance();
    await axiosInstance.put(`${BACKEND_URL}/like/${documentId}`, {
      liked: feedback,
    });
  } catch (error) {
    console.error("Error sending feedback:", error);
    throw error;
  }
};

export const getFeedbackStatus = async (
  documentId: string
): Promise<FeedbackType | null> => {
  try {
    const axiosInstance = ApiClient.getInstance().getAxiosInstance();
    const response = await axiosInstance.get<{
      content: { liked: FeedbackType | null };
    }>(`${BACKEND_URL}/like/${documentId}`);
    return response.data.content.liked;
  } catch (error) {
    console.error("Error fetching feedback status:", error);
    // It's better to return null than to throw an error for non-critical info
    return null;
  }
};
